import React from 'react';
import { gql } from '@urql/core';
import {
    CollegeConversationCardFragment,
    Content_File,
    Espin_Message_Type_Enum,
    Espin_Role_Enum,
} from '../../../../generated/spin-graphql';
import { useAppState } from '../../../../client/providers/AppProvider';
import { ConversationCard } from '../ConversationCard';

type Props = {
    conversation: CollegeConversationCardFragment;
    selected?: boolean;
    isFake?: boolean;
    index: number;
};

gql`
    fragment CollegeConversationCard on espin_message {
        college_id
        contents
        created_at
        viewed_at
        message_type
        player_user {
            player_profile {
                profile_image {
                    ...SpinContentImageDisplay
                }
                first_name
                last_name
                slug
            }
            deleted_at
        }
        high_school {
            name
            profile_pic_file {
                ...SpinContentImageDisplay
            }
            slug
        }
        parent_user_id
        id
    }
`;

export const CollegeConversationCard: React.FC<Props> = ({ conversation, selected, isFake, index }) => {
    const { user } = useAppState();
    let picture: Partial<Content_File>, nameLabel: string, lastMessage: string, slug: string;

    if (isFake) {
        picture = null;
        nameLabel = `Message ${index + 1}`;
        lastMessage = conversation.contents;
        slug = '';
    } else if (
        conversation.message_type === Espin_Message_Type_Enum.HighSchoolMessagesCollege ||
        conversation.message_type === Espin_Message_Type_Enum.CollegeMessagesHighSchool
    ) {
        picture = conversation.high_school?.profile_pic_file;
        nameLabel = conversation.high_school?.name ?? 'A High School';

        const lastMessageWasFromYou =
            user?.role === Espin_Role_Enum.EspinCollegeUser &&
            conversation.message_type === Espin_Message_Type_Enum.CollegeMessagesHighSchool;
        const lastMessageNameLabel = lastMessageWasFromYou ? 'You' : `${nameLabel}`;
        lastMessage = `${lastMessageNameLabel}: ${conversation.contents}`;
        slug = `/dashboard/messages/?high_school_slug=${conversation?.high_school?.slug}`;
    } else {
        picture = !!conversation.player_user?.deleted_at
            ? null
            : conversation?.player_user?.player_profile?.profile_image;
        nameLabel = !!conversation.player_user?.deleted_at
            ? 'Deleted User'
            : `${conversation?.player_user?.player_profile?.first_name} ${conversation?.player_user?.player_profile?.last_name}`;

        const lastMessageWasFromYou =
            user?.role === Espin_Role_Enum.EspinCollegeUser &&
            conversation.message_type === Espin_Message_Type_Enum.CollegeMessagesPlayer;
        const lastMessageNameLabel = lastMessageWasFromYou
            ? 'You'
            : `${!!conversation.player_user?.deleted_at ? 'Deleted User' : nameLabel}${
                  !!conversation?.parent_user_id ? "'s Parent" : ''
              }`;
        lastMessage = `${lastMessageNameLabel}: ${conversation.contents}`;
        slug = `/dashboard/messages/?player_slug=${conversation?.player_user?.player_profile?.slug}`;
    }

    return (
        <ConversationCard
            slug={slug}
            lastMessage={lastMessage}
            nameLabel={nameLabel}
            date={conversation.created_at}
            picture={picture}
            selected={selected}
            read={
                // have i viewed it or is it not what i'm interested in
                !!conversation.viewed_at || conversation.message_type !== Espin_Message_Type_Enum.PlayerMessagesCollege
            }
        />
    );
};
